import { useTranslation } from 'react-i18next';

import {
	ActionDecorations,
	ActionFeedback,
	ActionInput,
	ActionMedia,
	ActionSubmit,
	ActionText,
	AmountButton,
	GiverToggle,
	useActionInput,
} from '@bonusly/common-action-input';
import { Box, Flex, rem, Spacer } from '@bonusly/design-system';

import { Bonus } from '../../../../../types/bonus';
import { useCommentEdit } from './hooks/use-comment-edit';
import { SuggestedComments } from './suggested-comments';

const DynamicStyledActionText = () => {
	const { attachment, isLoadingAttachment } = useActionInput();
	return <ActionText inputStyles={{ minHeight: attachment || isLoadingAttachment ? undefined : rem(150) }} />;
};

export interface CommentEditorProps {
	bonus: Bonus;
	onDone: VoidFunction;
	parentBonus: Bonus;
}

export const CommentEditor = ({ bonus, onDone, parentBonus }: CommentEditorProps) => {
	const { t } = useTranslation('recognition');
	const { isOwnRecognition, onSuggestionSelected, onSuggestionCleared, ...config } = useCommentEdit(bonus, parentBonus, {
		onSuccess: onDone,
	});

	return (
		<Box w="full" ps={3}>
			<Box backgroundColor="bg.soft" borderRadius="md" boxShadow="sm" p={3} w="full">
				<ActionInput autofocus="end" {...config}>
					<Flex alignItems="center" columnGap={2}>
						<Box>
							<AmountButton />
						</Box>
						<GiverToggle />
					</Flex>

					<Box mb={2} position="relative">
						<DynamicStyledActionText />
						{isOwnRecognition && (
							<Box position="absolute" bottom={0} left={0} right={0} zIndex={1}>
								<SuggestedComments bonus={bonus} onSetText={onSuggestionSelected} onSuggestionCleared={onSuggestionCleared} />
							</Box>
						)}
						<ActionFeedback />
					</Box>

					<ActionMedia w="full" />

					<Flex
						alignItems={{ base: 'stretch', xs: 'flex-start' }}
						direction={{ base: 'column', xs: 'row' }}
						gap={2}
						id="comment-editor-submit-container"
						justifyContent="space-between"
						my={2}
						w="full"
					>
						<ActionDecorations />
						<Spacer />
						<ActionSubmit size="lg">{t('save', { ns: 'common' })}</ActionSubmit>
					</Flex>
				</ActionInput>
			</Box>
		</Box>
	);
};
